<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-pencil-ruler" 
        v-bind:show.sync="dialog"
        maxWidth="40%"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field autofocus :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome*"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field :error="!!errors.initials" :error-messages="errors.initials" v-model="model.initials" label="Abreviação*"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-hour-group
                                :model.sync="model.hour_group_id"
                                :error="errors.length > 0"  
                                :errors="errors.hour_group_id"
                                clearable
                                label="Grupo de Horário"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <sys-select-ambience-type
                                :model.sync="model.ambience_type_id"
                                :error="errors.length > 0"  
                                :errors="errors.ambience_type_id"
                                clearable
                                label="Tipo de Ambiente"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="2">
                            <s-text-field text-helper="Vagas Padrão" :error-messages="errors.students_max" v-model="model.students_max" label="Vagas" />
                        </v-col>
                        <v-col v-if="isAnima()" cols="12" sm="3">
                            <s-text-field :error-messages="errors.position" v-model="model.position" label="Posição" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field text-helper="Coluna referência para integração com o Totvs" code :error-messages="errors.column_ref" v-model="model.column_ref" label="Referência" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <s-text-field code :error-messages="errors.code" v-model="model.code" label="Código" />
                        </v-col>
                        
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.digital" label="Carga Horária Digital"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.has_teacher" label="Com Professor"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.has_paid_workload" label="Carga Horária Paga"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.has_time_table" label="Possui Horário"></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.has_ambience" label="Possui Ambiente"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.default" label="Padrão"></v-switch>
                        </v-col>
                    </v-row >
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.is_divisible" label="Divisível"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <s-switch inset text-helper="Permitir sobreposição de aulas na tela do horário" v-model="model.allow_overlap" label="Sobreposição"/>
                        </v-col>
                    </v-row >
                    <v-row>
                        <v-col cols="12" sm="6">
                            <s-switch inset text-helper="Gerar oferta automaticamente desse tipo de carga horária" v-model="model.generate_offer" label="Gerar Oferta" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <s-switch inset text-helper="Tipo de Carga Horária Prática" v-model="model.is_practice" label="Prática" />
                        </v-col>
                    </v-row >
                    <v-row>
                        <v-col cols="12" sm="6">
                            <s-switch inset v-model="model.active" label="Ativa" />
                        </v-col>
                    </v-row >
                    <v-row v-if="isAnima()">
                        <v-col cols="12" sm="6">
                            <s-switch
                                v-model="model.generate_division" 
                                inset 
                                label="Gerar Divisão"
                                text-helper="Dividir grade em principal e secundário quando transformar o catálogo em oferta"
                            />
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterWorkLoadType",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.error = false;
                this.errors = {};

                if(!this.model.id){
                    this.model.has_paid_workload = 1;
                    this.model.has_time_table = 1;
                    this.model.has_teacher = 1;
                    this.model.has_ambience = 1;
                    this.model.generate_offer = 1;
                    this.model.position = 0;
                    this.model.active = 1;
                }
            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Tipo de Carga Horária"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('workLoadType', ['ActionUpdateWorkLoadType', 'ActionCreateWorkLoadType']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, { institution_id: this.acesso.instituicao.id });
            
            if(edit) {
                this.ActionUpdateWorkLoadType(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateWorkLoadType(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>